<template>
  <div>
    <el-row>
      <el-col :span="8">
        <el-input type="number" v-model="days">
          <template slot="prepend">天数：</template>
          <template slot="append">
            <el-button slot="append" icon="el-icon-search" @click="loadData"></el-button>
          </template>
        </el-input>
      </el-col>
    </el-row>
    <h4>代理人</h4>
    <el-table :data="statistics">
      <el-table-column prop="date"
                       label="日期" />
      <el-table-column prop="agent_register"
                       label="当日注册人数" />
      <el-table-column prop="agent_dau"
                       label="当日活跃人数" />
      <el-table-column prop="checkin_count"
                       label="当日打卡数" />
      <el-table-column prop="vcard_count"
                       label="当日新增名片" />
      <el-table-column prop="agent_total"
                       label="累计注册" />
      <el-table-column prop="agent_have_client_now"
                       label="累计有客户" />
      <el-table-column prop="vcard_total"
                       label="累计名片数" />
      <el-table-column prop="wx_new_user"
                       label="新增的关注" />
      <el-table-column prop="wx_cancel_user"
                       label="取消关注" />
      <el-table-column prop="wx_cumulate_user"
                       label="总关注" />
    </el-table>

    <h4>客户</h4>
    <el-table :data="statistics">
      <el-table-column prop="date"
                       label="日期" />
      <el-table-column prop="client_create"
                       label="当日新建客户数" />
      <el-table-column prop="client_total"
                       label="累计客户数" />
    </el-table>

    <h4>文章</h4>
    <el-table :data="statistics">
      <el-table-column prop="date"
                       label="日期" />
      <el-table-column prop="cms_origin_count"
                       label="有效分享数" />
      <el-table-column prop="cms_share_count"
                       label="有效转发数" />
      <el-table-column prop="cms_browse_count"
                       label="有效阅读" />
    </el-table>

    <h4>保单</h4>
    <el-table :data="statistics">
      <el-table-column prop="date"
                       label="日期" />
      <el-table-column prop="policy_today_agent_count"
                       label="代理人总数" />
      <el-table-column prop="policy_today_user_count"
                       label="客户总数" />
      <el-table-column prop="policy_today_count"
                       label="保单总数" />
      <el-table-column prop="policy_agent_count"
                       label="累计代理人" />
      <el-table-column prop="policy_user_count"
                       label="累计客户" />
      <el-table-column prop="policy_count"
                       label="累计保单" />
    </el-table>
  </div>
</template>

<script>
import request from '../../api/request'

export default {
  name: "AgentStatistics",
  data() {
    return {
      statistics: [{}],
      days: 7
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      request.stat.post('summary', {days: parseInt(this.days)}).then(r => {
        this.statistics = r.data.list || [{}]
        console.log(r.data)
      })
      .catch(() => { })
    }
  }
}
</script>

<style scoped>
h4 {
  text-align: left;
}
</style>
